<div>
  <h1 class="error">404</h1>
  <hr class="line">
  <h1 class="not-find">找不到網頁</h1>
  <div class="home-btn">
    <button ejs-button [isPrimary]="true" routerLink="/main">回首頁</button>
  </div>
</div>

